module.exports = __webpack_public_path__ + "static/media/image_73.9397750f.png";